// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2RX3G","legacyBtn":"MutateMid_legacyBtn__3liY_"};